import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var BoardroomIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M13.1 1.934a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zM20.2 5.9a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zM12 23.2a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zM20.2 9.9a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zM19.1 15a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zM20.2 17.9a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0z"
                        }),
                        _jsx("path", {
                            d: "M16 4a1 1 0 011 1v14a1 1 0 01-1 1H8a1 1 0 01-1-1V5a1 1 0 011-1h8zm-1 14V6H9v12h6z",
                            fillRule: "evenodd",
                            clipRule: "evenodd"
                        }),
                        _jsx("path", {
                            d: "M4.77 7a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zM4.77 11a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zM5.87 13.9a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zM4.77 19a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2z"
                        })
                    ]
                })
            })
        ]
    });
};
BoardroomIcon.isCarinaIcon = true;
export default BoardroomIcon;
